/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  ToggleSwitchController,
  SelectController,
  RangeController,
  ChoiceBoxController,
  SimpleColorPickerController,
  GradientColorPickerController,
} from '../../../controllers/Base';

import { getOptionsThemes } from '../../../utils/controllersUtils/themeColors';

const StyleControllers = ({
  handle,
  config,
  data,
  extend,
  setExtend,
  selectedColumn,
  isGlobalThemeActive,
  forDrilldown = false,
}) => (
  <>
    <ControllersGroup
      title="Estilos"
      id="styles"
      extend={extend}
      setExtend={setExtend}
      sizeIncrease={config?.PalletsControl === 'custom' ? data?.index?.length : 0}
    >
      <ToggleSwitchController
        label="Habilitar área"
        handle={handle}
        kWord="AreaControl"
        configValue={config?.AreaControl?.checked}
        firstOption=""
        secondOption=""
        fullWidth
      />
      <RangeController
        label="Opacidade da área"
        handle={handle}
        kWord="AreaControl"
        configValue={config?.AreaControl?.opacity}
        min={0}
        max={1}
        step={0.1}
        precision={1}
        fullWidth
        disabled={!config?.AreaControl?.checked}
      />
      <ToggleSwitchController
        label="Exibir pontos"
        handle={handle}
        kWord="EnablePoints"
        configValue={config?.EnablePointsControl?.checked}
        firstOption=""
        secondOption=""
        fullWidth
      />
      <RangeController
        label="Tamanho dos pontos"
        handle={handle}
        kWord="EnablePoints"
        configValue={config?.EnablePointsControl?.pointsSize}
        min={1}
        max={20}
        fullWidth
        disabled={!config?.EnablePointsControl?.checked}
      />
      <RangeController
        label="Contorno dos pontos"
        handle={handle}
        kWord="EnablePointsBorder"
        configValue={config?.EnablePointsControl?.border}
        min={1}
        max={20}
        fullWidth
        disabled={!config?.EnablePointsControl?.checked}
      />
      <ChoiceBoxController
        label="Cor dos pontos"
        handle={handle}
        kWord="PointsColorControl2"
        options={[
          { value: 'brighter', label: 'Clara', id: 'brighter' },
          { value: 'darker', label: 'Escura', id: 'darker' },
          { value: 'custom', label: 'Customizada', id: 'custom' },
        ]}
        configValue={config?.PointsColorControl?.modifiers?.[0]?.[0] || 'custom'}
        fullWidth
        disabled={!config?.EnablePointsControl?.checked}
      />
      {typeof config?.PointsColorControl !== 'string' && (
        <RangeController
          label="Opacidade dos pontos"
          handle={handle}
          kWord="PointsOpacityControl"
          configValue={config?.PointsColorControl?.modifiers?.[0]?.[1] || '1'}
          min={0}
          max={2}
          step={0.1}
          precision={1}
          fullWidth
          disabled={!config?.EnablePointsControl?.checked}
        />
      )}
      {typeof config?.PointsColorControl === 'string' && (
        <SimpleColorPickerController
          label="Cor customizada"
          handle={handle}
          kWord="PointsColorControlColorPicker"
          configValue={config?.PointsColorControl}
          orientation="row"
          fullWidth
          disabled={!config?.EnablePointsControl?.checked}
        />
      )}
      <SelectController
        label="Formato da linha"
        handle={handle}
        kWord="LinesFormatControl"
        options={[
          { label: 'Linear', value: 'linear', id: 'linear' },
          { label: 'Interpolação 1', value: 'cardinal', id: 'cardinal' },
          { label: 'Interpolação 2', value: 'natural', id: 'natural' },
          { label: 'Ajuste suave', value: 'basis', id: 'basis' },
          { label: 'Degrau central', value: 'step', id: 'stet' },
          { label: 'Degrau anterior', value: 'stepBefore', id: 'stepBefore' },
          { label: 'Degrau posterior', value: 'stepAfter', id: 'stepAfter' },
        ]}
        configValue={config?.LinesFormatControl}
        fullWidth
      />
      <RangeController
        label="Espessura da linha"
        handle={handle}
        kWord="LineWidth"
        configValue={config?.LineWidth}
        min={0}
        max={20}
        fullWidth
      />
      {(selectedColumn || !forDrilldown) && (
        <ChoiceBoxController
          label="Paleta de cores"
          handle={handle}
          kWord="PalletsControl"
          options={selectedColumn ? [
            { label: 'Padrão', value: 'default', id: 'default' },
            { label: 'Degradê', value: 'gradient', id: 'gradient' },
            ...(forDrilldown ? [] : [{ label: 'Customizada', value: 'custom', id: 'custom' }]),
          ] : [
            { label: 'Padrão', value: 'default', id: 'default' },
            { label: 'Customizada', value: 'custom', id: 'custom' },
          ]}
          configValue={config?.PalletsControl}
          fullWidth
          text="Utilizando tema global"
          disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
        />
      )}
      {config?.PalletsControl === 'default' && (
        <SelectController
          label="Tema"
          handle={handle}
          kWord="ColorTheme"
          options={getOptionsThemes()}
          configValue={config?.ColorTheme?.scheme}
          fullWidth
          text="Utilizando tema global"
          disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
        />
      )}
      {selectedColumn && config?.PalletsControl === 'gradient' && (
        <GradientColorPickerController
          handle={handle}
          firstColorVal={config?.GradientPickerControl?.color1 || '#4711B2'}
          firstColorKWord="GradientFirstColor"
          secondColorVal={config?.GradientPickerControl?.color2 || '#FF9626'}
          secondColorKWord="GradientSecondColor"
          thirdColorVal={config?.GradientPickerControl?.color3}
          thirdColorKWord="GradientThirdColor"
          fullWidth
          orientation="row"
          text="Utilizando tema global"
          disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
        />
      )}
      {config?.PalletsControl === 'custom'
      && (!selectedColumn ? data?.columns?.map((col, i) => {
        if (col === 'Totais') return null;
        return (
          <SimpleColorPickerController
            dataColorTarget={col.toString()}
            key={`${col}_i${i}`}
            label={col}
            handle={handle}
            kWord="Colors"
            configValue={config?.Colors[col]}
            orientation="row"
            fullWidth
            text="Utilizando tema global"
            disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
          />
        );
      }) : (
        data?.index?.map((col, i) => {
          if (col === 'Totais') return null;
          return (
            <SimpleColorPickerController
              dataColorTarget={col.toString()}
              key={`${col}_i${i}`}
              label={col}
              handle={handle}
              kWord="Colors"
              configValue={config?.Colors[col]}
              orientation="row"
              fullWidth
              text="Utilizando tema global"
              disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
            />
          );
        })
      ))}
      <ToggleSwitchController
        label="Utilizar tema global"
        handle={handle}
        kWord="UseGlobalColor"
        configValue={config?.UseGlobalColor}
        firstOption=""
        secondOption=""
        fullWidth
      />
      <ToggleSwitchController
        label="Utilizar fonte global"
        handle={handle}
        kWord="UseGlobalFont"
        configValue={config?.UseGlobalFont}
        firstOption=""
        secondOption=""
        fullWidth
      />
    </ControllersGroup>
  </>
);

StyleControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedColumn: PropTypes.objectOf(PropTypes.any),
  isGlobalThemeActive: PropTypes.bool,
  forDrilldown: PropTypes.bool,
};

export default StyleControllers;
